export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12036.0e954f75.jpg";